import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Card, CardBody, CardFooter, CardHeader} from 'reactstrap';

import './OfferExampleCard.scss';

export default class OfferExampleCard extends PureComponent {
  static propTypes = {
    footer: PropTypes.string,
    tag: PropTypes.string,
    text: PropTypes.element,
    title: PropTypes.string,
  };

  static defaultProps = {
    footer: null,
    tag: 'div',
    text: null,
    title: null,
  };

  render() {
    const {children, footer, tag, title} = this.props;

    return <Card className="offer-example-card" tag={tag}>
      <CardHeader className="d-flex align-items-center justify-content-center" tag="h3">{title}</CardHeader>
      <CardBody className="text-left">
        {children}
      </CardBody>
      {footer ? <CardFooter>{footer}</CardFooter> : ''}
    </Card>;
  }
}
